import { Action, createReducer, on } from '@ngrx/store';

import * as HomeActions from './home.actions';

export interface State {
    supportTabIndex: number;
    scenariosTabIndex: number;
    scenariosStepIndex: number;
    permissionsTabIndex: number;
    deviceTabIndex: number;
}

const initialState: State = {
    supportTabIndex: 0,
    scenariosTabIndex: 0,
    scenariosStepIndex: 0,
    permissionsTabIndex: 0,
    deviceTabIndex: 0,
};

const homeReducer = createReducer(
    initialState,
    on(HomeActions.selectSupportTab, (state, payload) => ({ ...state, supportTabIndex: payload.index })),
    on(HomeActions.selectScenariosTab, (state, payload) => ({ ...state, scenariosTabIndex: payload.index })),
    on(HomeActions.selectScenariosStep, (state, payload) => ({ ...state, scenariosStepIndex: payload.index })),
    on(HomeActions.selectPermissionsTab, (state, payload) => ({ ...state, permissionsTabIndex: payload.index })),
    on(HomeActions.selectDeviceTab, (state, payload) => ({ ...state, deviceTabIndex: payload.index })),
);

export const reducer = (state: State | undefined, action: Action): State => homeReducer(state, action);
